import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import ParallaxComponent from "./ParallaxComponent";

function HeroSection(props) {
  return (
    <Section style={{padding:"0px"}} >

        <ParallaxComponent {...props}/>
    </Section>
  );
}

export default HeroSection;
